"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[630],{

/***/ 6630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



var Spacer = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data;
    var size = data.size;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("spacer", {
            "h-[125px]": size == "default",
            "h-[250px]": size == "large"
        }),
        "data-theme": "gray"
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Spacer);


/***/ })

}]);